function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#DA1919"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M59.23 36.786c.503-2.18.77-4.452.77-6.786C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 1.253 0 2.488-.077 3.7-.226",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.415 0c.674 2.171.281 3.723-1.177 4.654-1.46.93-4.386 1.657-8.78 2.179",
  transform: "translate(1 1) translate(8.057 1.657)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.38 3.416c-.254 2.1.038 3.993.876 5.682 2.128 4.29 6.94 10.546 6.518 12.716-.27 1.381-2.311.542-4.965 3.157-1.553 1.53 1.152 4.568-.829 6.121-.578.454-1.945.236-4.07 0-.668-.073-1.76.065-3.277.414M14.126 33.839c2.221-.273 3.718-.353 4.49-.24.998.147 1.952.216 2.189.853.48 1.29-.605 3.649-.588 4.885.015 1.148.671 2.412 0 3.325-.594.808-2.572 1.314-3.87 1.467-1.145.136-4.652.184-7.81-.976-1.74-.64-4.586-2.227-8.537-4.765M8.443 14.253c1.09.899 2.34 1.348 3.747 1.348s2.656-.45 3.746-1.348M8.265 43.226c-.61 2.228-.914 3.904-.914 5.028 0 1.125.305 2.801.914 5.029",
  transform: "translate(1 1) translate(8.057 1.657)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1) translate(30.914 30.914)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4.486,
  height: 1,
  x: 0.5,
  y: 1.871,
  rx: 0.5,
  transform: "rotate(-25 2.743 1.871)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.486,
  height: 1,
  x: 0.5,
  y: 5.954,
  rx: 0.5,
  transform: "scale(1 -1) rotate(-25 -24.114 0)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.114,
  height: 1,
  x: 1.186,
  y: 3.913,
  rx: 0.5,
  transform: "matrix(1 0 0 -1 0 7.826)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M2 22.217c3.989-2.115 6.942-3.921 8.86-5.417 1.918-1.496 4.671-4.142 8.26-7.938",
  transform: "translate(1 1) rotate(-24 108.849 -43.284)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.106 8.952c.121-2.224.988-4.075 2.6-5.553C23.32 1.922 25.52.962 28.306.521c-.58 2.96-1.613 5.121-3.098 6.482-1.485 1.362-3.52 2.011-6.102 1.95zM13.827 13.009c-1.488-1.659-2.184-3.58-2.089-5.765.096-2.185.973-4.42 2.632-6.702 1.683 2.503 2.48 4.762 2.393 6.774-.088 2.013-1.066 3.91-2.936 5.693zM14.666 14.01c1.734-1.399 3.69-1.993 5.867-1.784 2.177.21 4.362 1.203 6.555 2.98-2.588 1.549-4.885 2.227-6.89 2.034-2.006-.193-3.85-1.27-5.532-3.23zM7.625 19.477c1.685-1.458 3.618-2.12 5.801-1.987 2.183.133 4.401 1.05 6.655 2.749-2.532 1.639-4.804 2.397-6.815 2.274-2.011-.123-3.891-1.135-5.64-3.036zM6.817 18.752c-1.487-1.659-2.183-3.58-2.088-5.765.095-2.185.973-4.419 2.632-6.702 1.683 2.504 2.48 4.762 2.393 6.775-.088 2.012-1.067 3.91-2.937 5.692z",
  transform: "translate(1 1) rotate(-24 108.849 -43.284)"
}))));

var SvgIconAllergyGrassActive = function SvgIconAllergyGrassActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAllergyGrassActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-allergy_grass_active.430f9430.svg";
export { ForwardRef as ReactComponent };